
const data = {
    namespaced: true,
    state:{
        scale:1

    },
    mutations:{
        SET_scale(state, val){
            state.scale = val;
        }

    }
};

export default data;